import { render, staticRenderFns } from "./BinsDialog.vue?vue&type=template&id=186821b2&scoped=true"
import script from "./BinsDialog.vue?vue&type=script&lang=js"
export * from "./BinsDialog.vue?vue&type=script&lang=js"
import style0 from "./BinsDialog.vue?vue&type=style&index=0&id=186821b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186821b2",
  null
  
)

export default component.exports